<template>
  <form :action="formPath" method="POST">
    <input :value="csrfToken" type="hidden" name="authenticity_token" />
    <div class="row">
      <div class="col-xs-24 col-md-16">
        <FormInputFloatingLabel :required="true" :label="t.email" v-model="email" name="email" />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-24 col-md-16">
        <FormRecaptcha :parameters="recaptchaParameters" />
        <CheckoutButtonCheckout
          :active_text="t.next"
          :inactive_text="t.please_wait"
          class="w-100 ch-Address_Submit"
        ></CheckoutButtonCheckout>
      </div>
    </div>
  </form>
</template>

<script>
import CheckoutButtonCheckout from "./CheckoutButtonCheckout";
import FormInputFloatingLabel from "./FormInputFloatingLabel";
import FormRecaptcha from "./FormRecaptcha";

export default {
  name: "LoginStrategyGuest",
  components: {
    CheckoutButtonCheckout,
    FormInputFloatingLabel,
    FormRecaptcha,
  },
  props: {
    t: {
      type: Object,
      required: true,
    },
    recaptchaParameters: {
      type: Object,
      required: true,
    },
    formPath: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: "",
    };
  },
};
</script>
